<template>
  <div>
    <ListSelection
      :List="giftcardslist"
      :Label="$t('gift_card')"
      :Placeholder="$t('choose_gift_card')"
      @selection="action"
    />
    <BasicStatisticsRow
      :basicstatisticspath="giftcardstatisticspathbasic"
      :key="componentKey"
    />
  </div>
</template>

<script>
import BasicStatisticsRow from "../components/BasicStatisticsRow.vue";
import ListSelection from "../components/ListSelection.vue";

export default {
  name: "GiftCardStatistics",
  components: {
    BasicStatisticsRow,
    ListSelection,
  },
  data: () => ({
    giftcardslist: [],
    giftcardspath: "/2.0/newbe/giftcards?sessionid=",
    giftcards: [],
    selectionId: 0,
    giftcardstatisticspathbasic: "",
    loadReady: false,
    componentKey: 0,
  }),
  methods: {
    getList() {
      this.$http
        .get(this.giftcardspath + this.$store.getters.getToken)
        .then((response) => {
          if (response.status == 200) {
            this.giftcards = response.data.giftcards;
            this.loadReady = true;
            this.checkContent();
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          window.__logAxiosErrorIfDebug(error, {
            context: "GiftCardStatistics.vue - getList",
          });
          this.$root.$emit("session_failed");
          return error;
        });
    },
    checkContent() {
      this.giftcardslist = [];
      this.giftcards.forEach(function (giftcard) {
        this.giftcardslist.push({
          text: giftcard.title,
          value: giftcard.id,
          selected: this.selectionId === this.giftcards.id ? true : false,
        });
      }, this);
    },
    action(val) {
      console.log(val);
      this.giftcardstatisticspathbasic =
        "/2.0/newbe/giftcards/" + val + "/statistics/basic?sessionid=";
      this.componentKey += 1;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
